import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ValueCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
}

const ValueCard: React.FC<ValueCardProps> = ({ icon, title, description }) => {
  return (
    <div
      style={{
        width: '240px',
        height: '205px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '20px',
        background: 'linear-gradient(110deg, rgba(0, 31, 102, 0.5) 7.423634572072071%, rgba(0, 63, 255, 0.25) 45.937148085585584%, rgba(0, 51, 179, 0.5) 78.36958051801803%)',
        alignContent: 'flex-start',
        flexWrap: 'nowrap',
        border: '1px solid #0033b3',
        borderRadius: '8px'
      }}
    >
      {/* Icon */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{
            color: '#FFFFFF',
            fontSize: '42px',
            marginBottom: '20px'
          }}
        />
      </div>

      {/* Title */}
      <h3
        style={{
          color: '#FFFFFF',
          fontSize: '18px',
          fontWeight: '700',
          fontFamily: 'Inter, sans-serif',
          margin: '0',
          textAlign: 'center',
          width: '100%'
        }}
      >
        {title}
      </h3>

      {/* Description */}
      <p
        style={{
          color: '#FFFFFF',
          fontSize: '18px',
          fontWeight: '400',
          fontFamily: 'Source Sans 3, sans-serif',
          margin: '0',
          textAlign: 'center',
          width: '100%',
          lineHeight: '1.4'
        }}
      >
        {description}
      </p>
    </div>
  );
};

export default ValueCard;
